import React from "react";
import { Box, Skeleton, SkeletonProps, Stack, Typography } from "@mui/material";
import { APP_TEXT_SECONDARY } from "../createShared";

export function UsageSkeleton({ sx, ...props }: SkeletonProps) {
  return (
    <Skeleton
      variant="rounded"
      animation="wave"
      aria-hidden="true"
      {...props}
      sx={[
        {
          bgcolor: "rgba(255,255,255,0.08)",
          maxWidth: "100%",
          transform: "none",
          "&::after": {
            background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.06), transparent)",
          },
          "@media (prefers-reduced-motion: reduce)": {
            animation: "none",
            "&::after": { animation: "none" },
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}

export function UsageOverviewLoadingShell() {
  return (
    <Box role="status" aria-label="Loading spending overview" aria-busy="true">
      <Typography color={APP_TEXT_SECONDARY}>Fable tokens spent</Typography>
      <Box sx={{ height: 52, mt: 0.5, display: "flex", alignItems: "center" }}>
        <UsageSkeleton width={180} height={38} />
      </Box>
      <Box sx={{ height: 19.5, display: "flex", alignItems: "center" }}>
        <UsageSkeleton width={150} height={14} />
      </Box>
      <Stack spacing={1.5} sx={{ height: { xs: 180, sm: 220 }, mt: 3 }}>
        <UsageSkeleton sx={{ flex: 1 }} />
        <Stack direction="row" justifyContent="space-around">
          {Array.from({ length: 7 }, (_, index) => (
            <UsageSkeleton key={index} width="7%" height={14} />
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
